import { useQuery } from '@tanstack/react-query';
import { FetchHelper } from '../stores/authTokens/FetchHelper';

const fetchHelper = new FetchHelper();

export type EventsPageResponse = {
  CalendarEvents?: unknown[];
  Categories?: unknown[];
};

export async function fetchEventsPage(
  nexudusToken: string,
  host: string,
  page: number,
  size: number,
  pastEvents: boolean,
): Promise<EventsPageResponse> {
  const apiUrl = `https://${host.split(':')[0]}:443`;
  const url = `${apiUrl}/en/events?_depth=3&size=${size}&page=${page}&pastEvents=${pastEvents}`;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (nexudusToken) {
    headers.Authorization = `Bearer ${nexudusToken}`;
  }

  const result = await fetchHelper.fetch(url, {
    method: 'GET',
    headers,
  });
  return result.json();
}

const DEFAULT_SIZE = 25;

export function eventsQueryConfig(
  nexudusToken: string,
  host: string,
  page: number,
  pastEvents: boolean,
) {
  const tokenHash = nexudusToken ? nexudusToken.slice(0, 5) : '';
  return {
    queryKey: ['events', { tokenHash, host }],
    queryFn: () =>
      fetchEventsPage(nexudusToken, host, page, DEFAULT_SIZE, pastEvents),
    staleTime: 1000 * 60 * 60 * 24,
    enabled: !!nexudusToken,
  };
}

export function useEventsQuery(
  nexudusToken: string,
  host: string,
  page: number = 1,
  pastEvents: boolean = false,
) {
  return useQuery(eventsQueryConfig(nexudusToken, host, page, pastEvents));
}
